// Which payment action the Job Detail card may offer, given the job's payment
// state. Sibling to JobCalendar/utils/sendTrackRules.js — pure, no React.

const isPaidTier = (tier) => tier !== "Free";

/**
 * Picks the one payment button the Job Detail card should show.
 *
 * The backend rejects each of these calls if the payment is in the wrong
 * state, so offering the wrong button means the user clicks and gets an error
 * toast. Each state allows exactly one action, which is why at most one flag
 * here is ever true.
 */
export const computePaymentActions = ({ status, paymentId, tier } = {}) => ({
  canMarkPaid: status === "no_payment" && isPaidTier(tier),
  // No tier check. Someone who downgrades still has to be able to stop a
  // payment link they already sent.
  canCancelRequest: status === "unpaid" && Boolean(paymentId),
  canUndo: status === "paid_manual" && Boolean(paymentId) && isPaidTier(tier),
  // No tier check: clearing moves no money, so the backend allows it on Free.
  canRestart:
    (status === "refunded" || status === "dispute_lost") && Boolean(paymentId),
  // Once a request or payment row exists, its amount is fixed.
  canEditQuote: status === "no_payment",
});
